import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, adminApi } from "./api";

const AuthCtx = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    }
  }, []);

  const fetchAdmin = useCallback(async () => {
    const t = localStorage.getItem("admin_token");
    if (!t) {
      setAdmin(null);
      return;
    }
    try {
      const r = await adminApi.get("/auth/admin/me");
      setAdmin(r.data);
    } catch {
      localStorage.removeItem("admin_token");
      setAdmin(null);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    Promise.all([fetchUser(), fetchAdmin()]).finally(() => setLoading(false));
  }, [fetchUser, fetchAdmin]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("logout request failed:", e); }
    localStorage.removeItem("session_token");
    setUser(null);
  };

  const logoutAdmin = () => {
    localStorage.removeItem("admin_token");
    setAdmin(null);
  };

  return (
    <AuthCtx.Provider
      value={{ user, admin, loading, fetchUser, fetchAdmin, logout, logoutAdmin, setAdmin }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
